import { EventProfileBlockedPage } from "gsintegrations";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resolvePageKeyFromPathname } from "../analytics/pageRegistry";
import { trackProductAccessDenied } from "../analytics/product";
import { ROUTE } from "../constants/routes";
import {
  buildProductBaseFromRegistry,
  useProductAnalyticsContext,
} from "../hooks/useProductAnalyticsContext";

const EventProfileBlocked = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useProductAnalyticsContext();

  useEffect(() => {
    const registryEntry = resolvePageKeyFromPathname(location.pathname);
    trackProductAccessDenied(
      registryEntry
        ? buildProductBaseFromRegistry(registryEntry, context, location)
        : {
            pageKey: "event_profile_blocked",
            routePath: location.pathname,
            sourcePage: "EventProfileBlocked",
            productArea: "events",
            activeProfileType: context.activeProfileType,
            terreiroId: context.terreiroId,
            mediumId: context.mediumId,
          },
      {
        reasonCode: "event_terreiro_profile_required",
      },
    );
  }, [context, location]);

  const handleGoBackWithFallback = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(ROUTE.APP_HOME, { replace: true });
  };

  return (
    <EventProfileBlockedPage
      countdownSeconds={10}
      onGoBackNow={handleGoBackWithFallback}
      onCountdownComplete={handleGoBackWithFallback}
    />
  );
};

export default EventProfileBlocked;
